<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <b-form>
                    <div class="form-row">
                      <div class="col-md-4">
                        <label>{{ $t('Centrals') }}:</label>
                        <v-select
                            :options="centers"
                            :reduce="c => c.id"
                            :label="'name'"
                            v-model="refueling.center_id"
                            class="vselect"
                            disabled
                        />
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('Unit') }}:</label>
                        <v-select
                            :options="units"
                            :reduce="u => u.id"
                            :label="'name'"
                            v-model="refueling.unit_id"
                            class="vselect"
                            disabled
                        />
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('Vehicle') }}:</label>
                        <v-select
                            :options="vehicles"
                            :reduce="u => u.id"
                            :label="'name'"
                            v-model="refueling.vehicle_id"
                            class="vselect"
                            disabled
                        />
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('Gas station') }}:</label>
                        <v-select
                            :options="gas_stations"
                            :reduce="u => u.id"
                            :label="'name'"
                            v-model="refueling.gas_station_id"
                            class="vselect"
                            disabled
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>{{ $t('Refueling date') }}:</label>
                        <b-form-input
                            type="date"
                            v-model="refueling.refueling_date"
                            disabled
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>{{ $t('Fuel type') }}:</label>
                        <b-form-input
                            type="text"
                            v-model="refueling.fuel_type"
                            disabled
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>{{ $t('Quantity (liters)') }}:</label>
                        <b-form-input
                            type="text"
                            v-model="refueling.liters"
                            disabled
                        />
                      </div>
                      <div class="form-group col-md-2">
                        <label>{{ $t('Value') }}:</label>
                        <b-form-input
                            type="text"
                            :value="$options.filters.money(refueling.value)"
                            readonly
                            disabled
                        />
                      </div>
                      <div class="form-group col-md-12">
                        <label>{{ $t('Description') }}:</label>
                        <b-form-textarea
                            v-model="refueling.description"
                            rows="3"
                            disabled
                        />
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('Requester') }}:</label>
                        <b-form-input
                            type="text"
                            :value="requesterName"
                            readonly
                            disabled
                        />
                      </div>
                      <div class="col-md-4">
                        <label>{{ $t('Requester') }}:</label>
                        <b-form-input
                            type="text"
                            :value="requesterName"
                            readonly
                            disabled
                        />
                      </div>
                      <div v-if="refueling.url" class="mb-3 align-items-center">
                        <label>{{ $t('File') }}:</label>
                        <a
                            :href="refueling.url"
                            target="_blank"
                            rel="noopener"
                            class="btn btn-outline-primary d-flex align-items-center rounded-pill file_button"
                            style="gap: 8px; padding: 8px 16px; text-decoration: none;"
                        >
                          <i class="fas fa-download"></i>
                          {{ $t('Download file') }}
                        </a>
                      </div>
                    </div>
                    <div class="block text-right">
                      <router-link to="/refuelings" class="btn btn-back">
                        <i class="fa fa-arrow-left"></i> {{ $t("To Go Back") }}
                      </router-link>
                    </div>
                  </b-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { BForm, BFormInput, BFormTextarea } from "bootstrap-vue";
import axios from "axios";
import UploadFile from "@/layouts/components/UploadFile.vue";

export default {
  data() {
    return {
      refueling: {},
      centers: [],
      units: [],
      vehicles: [],
      professionals: [],
      gas_stations: [],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    requesterName() {
      const prof = this.professionals.find(p => p.id === this.refueling.requester_id);
      return prof ? prof.name : '';
    },
    approverName() {
      const prof = this.professionals.find(p => p.id === this.refueling.approver_id);
      return prof ? prof.name : '';
    }
  },
  filters: {
    money(value) {
      if (typeof value !== "number") value = parseFloat(value);
      if (isNaN(value)) return "";
      return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }
  },
  methods: {
    getRefueling(id) {
      const api = this.$store.state.api + "refuelings/" + id;
      axios.get(api).then((response) => {
        this.refueling = response.data.data[0];
        this.getUnitsCenter(this.refueling.center_id);
        this.getVehicles(this.refueling.unit_id);
      });
    },
    getCenters() {
      axios.get(this.$store.state.api + "centers/").then((response) => {
        this.centers = response.data.data;
      });
    },
    getUnitsCenter(center_id) {
      axios.get(this.$store.state.api + "centers/unit/" + center_id).then((response) => {
        this.units = response.data;
      });
    },
    getVehicles(unit_id) {
      axios.get(this.$store.state.api + "units/vehicles/" + unit_id).then((response) => {
        this.vehicles = response.data;
      });
    },
    getProfessionals() {
      axios.get(this.$store.state.api + "professionals/").then((response) => {
        this.professionals = response.data.data;
      });
    },
    getGasStations() {
      axios.get(this.$store.state.api + "gasstations/").then((response) => {
        this.gas_stations = response.data.data;
      });
    },
  },
  mounted() {
    const id = this.$route.params.id;
    this.getCenters();
    this.getProfessionals();
    this.getGasStations();
    if (id) {
      this.getRefueling(id);
    }
  },
  components: {
    UploadFile,
    vSelect,
    BForm,
    BFormInput,
    BFormTextarea,
  },
};
</script>

<style>
.file_button {
  border-radius: 50px;
  gap: 8px;
  padding: 8px 16px;
  text-decoration: none;
}
</style>